import axios from "axios";
import { ConvertUsdToRewardsRequest, RewardsPrice } from "redmond";

import { config } from "../../config";

import { rewardsApiPrefix } from "../paths";

const END_POINT: string = `${rewardsApiPrefix}/convert/redeem/usdToRewards`;

export const convertUsdToRewards = (
  request: ConvertUsdToRewardsRequest
): Promise<RewardsPrice> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(END_POINT, request, {
        baseURL: config.baseURL,
      });

      resolve(res.data.value);
    } catch (e) {
      reject(e);
    }
  });
